import { Button, Modal } from "react-bootstrap"
import { StoreProductModel } from "../../../models"
// import { FaMinus, FaPlus } from "react-icons/fa"
import { useLayout } from "../../../context"
import { useEffect, useState } from "react"
import { useCart } from "../../../hooks"

type Props = {
  show: boolean,
  handleClose: () => void,
  product: StoreProductModel
}

const CartConfirmModal: React.FC<Props> = ({show, product, handleClose}) => {

  const { setShowCart } = useLayout();
  const { getCartItem } = useCart();

  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (show && !hovered) {
      const timer = setTimeout(handleClose, 5 * 1000);
      return () => clearTimeout(timer);
    }
  }, [show, hovered]);

  const cartProduct = getCartItem(product.id);

  const handleShowCart = () => {
    setShowCart(true);
    handleClose();
  }

  // const isMobile = window.innerWidth <= 768;

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop={false}
        keyboard={false}
        dialogClassName="cartpopup-modal"
        centered={false}
        bsPrefix="modal custom-modal-align"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Modal.Header className="pb-0 pt-0" closeButton>
          <Modal.Title className="modal-title-name border-none pb-0">
            {cartProduct?.product_name}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex justify-content-between align-items-center">
            <span>
              {cartProduct?.product_qty} item{cartProduct?.product_qty && cartProduct?.product_qty > 1 ? "s" : ""}
            </span>
            {/* <div className="quantity-wrapper d-flex align-items-center">
              <Button variant="light" className="quantity-btn" disabled={(cartProduct?.product_qty || 0) < 2} onClick={() => decreaseQuantity(product.id)}>
                <FaMinus />
              </Button>
              <span className="fw-bold px-2">{cartProduct?.product_qty}</span>
              <Button variant="light" className="quantity-btn" onClick={() => increaseQuantity(product.id)}>
                <FaPlus />
              </Button>
            </div> */}
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-between">
          <Button className="secondary-button" onClick={handleShowCart}>Go to Cart</Button>
          {/* <Button className="teal-btn primary-btn" onClick={handleClose}>Continue Shopping</Button> */}
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CartConfirmModal